import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Container } from 'reactstrap';
import * as elements from '../data/Elements';
import * as Records from '../store/Records';
import * as utility from '../data/Utility';

const createRecordEventType = {
    activitiesCodeSet: "activitiesCodeSet",
    activitiesRemark: "activitiesRemark",
    analysisClassSet: "analysisClassSet",
    analysisRemark: "analysisRemark",
    analysisRhythmSet: "analysisRhythmSet",
    clinicalEvaluationStartDate: "clinicalEvaluationStartDate",
    clinicalEvaluationStartTime: "clinicalEvaluationStartTime",
    clinicalEvaluationUpdateDate: "clinicalEvaluationUpdateDate",
    clinicalEvaluationUpdateTime: "clinicalEvaluationUpdateTime",
    d_recanalysis_key: "d_recanalysis_key",
	enrollmentReportKey: "enrollmentReportKey",
    measuredHrMax: "measuredHrMax",
    measuredHrMean: "measuredHrMean",
    measuredHrMin: "measuredHrMin",
    measuredHrN: "measuredHrN",
    reportNr: "reportNr",
    studyReportNr: "studyReportNr",
    symptomsCodeSet: "symptomsCodeSet",
    symptomsRemark: "symptomsRemark"
}

class CreateRecordEvent extends React.Component {
    constructor(props) {
        super(props);

        const disabled = utility.propCheck(props.disabled, false);
        const handleKeyDown = utility.propCheck(props.handleKeyDown, null);
        const saveButton = utility.propCheck(props.saveButton, false);
        this.state = {
            disabled: disabled,
            edited: false,
            handleKeyDown: handleKeyDown,
            saveButton: saveButton
        };

        this.handleSave = this.handleSave.bind(this);
        this.handleValue = this.handleValue.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps != null &&
            prevProps.disabled !== this.props.disabled &&
            this.props.disabled !== this.state.disabled) {
            this.setState({
                disabled: this.props.disabled
            });
        }
    }

    handleSave() {
        this.props.recordsDispatch.setRefresh( true );
        this.setState({
            edited: false
        });
    }

    handleValue(type, value) {
        const record = this.props.recordsState.record;

        switch (type) {
            case createRecordEventType.activitiesCodeSet:
                record.activitiesCodeSet = value;
                break;
            case createRecordEventType.activitiesRemark:
                record.activitiesRemark = value;
                break;
            case createRecordEventType.analysisClassSet:
                record.analysisClassSet = value;
                break;
            case createRecordEventType.analysisRemark:
                record.analysisRemark = value;
                break;
            case createRecordEventType.analysisRhythmSet:
                record.analysisRhythmSet = value;
                break;
            case createRecordEventType.clinicalEvaluationStartDate:
                record.clinicalEvaluationStartDateTime = utility.getDateTimeFromInputDate(value, record.clinicalEvaluationStartDateTime);
                break;
            case createRecordEventType.clinicalEvaluationStartTime:
                record.clinicalEvaluationStartDateTime = utility.getDateTimeFromInputTime(value, record.clinicalEvaluationStartDateTime);
                break;
            case createRecordEventType.clinicalEvaluationUpdateDate:
                record.clinicalEvaluationUpdateDateTime = utility.getDateTimeFromInputDate(value, record.clinicalEvaluationUpdateDateTime);
                break;
            case createRecordEventType.clinicalEvaluationUpdateTime:
                record.clinicalEvaluationUpdateDateTime = utility.getDateTimeFromInputTime(value, record.clinicalEvaluationUpdateDateTime);
                break;
            case createRecordEventType.d_recanalysis_key:
                record.d_recanalysis_key = value;
                break;
            case createRecordEventType.measuredHrMax:
                record.measuredHrMax = value;
                break;
            case createRecordEventType.measuredHrMean:
                record.measuredHrMean = value;
                break;
            case createRecordEventType.measuredHrMin:
                record.measuredHrMin = value;
                break;
            case createRecordEventType.measuredHrN:
                record.measuredHrN = value;
                break;
            case createRecordEventType.enrollmentReportKey:
                record.enrollmentReportKey = value;
                break;
            case createRecordEventType.reportNr:
                record.reportNr = value;
                break;
            case createRecordEventType.studyReportNr:
                record.studyReportNr = value;
                break;
            case createRecordEventType.symptomsCodeSet:
                record.symptomsCodeSet = value;
                break;
            case createRecordEventType.symptomsRemark:
                record.symptomsRemark = value;
                break;
            default:
                break;
        }

        this.props.recordsDispatch.set(record);
        if (!this.state.edited) {
            this.setState({
                edited: true
            });
        }
    }

    render() {
        //const disabled = this.state.disabled;
        const disabled = true;
        const handleKeyDown = this.state.handleKeyDown;
        //var activitiesCodeSet = null;
        var activitiesRemark = null;
        //var analysisClassSet = null;
        var analysisRemark = null;
        //var analysisRhythmSet = null;
        var clinicalEvaluationStartDateTime = null;
        //var clinicalEvaluationUpdateDateTime = null;
        //var d_recanalysis_key = null;
        var measuredHrMax = null;
        var measuredHrMean = null;
        var measuredHrMin = null;
        //var measuredHrN = null;
        var enrollmentReportKey = null;
        var record = this.props.recordsState.record;
        //var reportNr = null;
        const save = "Save";
        const showSaveButton = (
            this.state.edited &&
            this.state.saveButton
        );
        //var studyReportNr = null;
        //var symptomsCodeSet = null;
        var symptomsRemark = null;

        if (record != null) {
            //activitiesCodeSet = elements.getFormGroup("Activities Code Set", true, elements.getInput("activitiesCodeSetInput", disabled, (e) => this.handleValue(createRecordEventType.activitiesCodeSet, e.target.value), handleKeyDown, elements.inputTypes.text, record.activitiesCodeSet));
            activitiesRemark = elements.getFormGroup("Activity", true, elements.getInput("activitiesRemarkInput", disabled, (e) => this.handleValue(createRecordEventType.activitiesRemark, e.target.value), handleKeyDown, elements.inputTypes.text, record.activitiesRemark));
            //analysisClassSet = elements.getFormGroup("Analysis Class Set", true, elements.getInput("analysisClassSetInput", disabled, (e) => this.handleValue(createRecordEventType.analysisClassSet, e.target.value), handleKeyDown, elements.inputTypes.text, record.analysisClassSet));
            analysisRemark = elements.getFormGroup("Findings", true, elements.getInput("analysisRemarkInput", disabled, (e) => this.handleValue(createRecordEventType.analysisRemark, e.target.value), handleKeyDown, elements.inputTypes.text, record.analysisRemark));
            //analysisRhythmSet = elements.getFormGroup("Analysis Rhythm Set", true, elements.getInput("analysisRhythmSetInput", disabled, (e) => this.handleValue(createRecordEventType.analysisRhythmSet, e.target.value), handleKeyDown, elements.inputTypes.text, record.analysisRhythmSet));
            clinicalEvaluationStartDateTime = elements.getFormGroup("Clinical Evaluation Start DateTime", true, elements.getInput("clinicalEvaluationStartDateInput", disabled, (e) => this.handleValue(createRecordEventType.clinicalEvaluationStartDate, e.target.value), handleKeyDown, elements.inputTypes.date, record.clinicalEvaluationStartDateTime), elements.getInput("clinicalEvaluationStartTimeInput", disabled, (e) => this.handleValue(createRecordEventType.clinicalEvaluationStartTime, e.target.value), handleKeyDown, elements.inputTypes.time, record.clinicalEvaluationStartDateTime));
            //clinicalEvaluationUpdateDateTime = elements.getFormGroup("Clinical Evaluation Update DateTime", true, elements.getInput("clinicalEvaluationUpdateDateInput", disabled, (e) => this.handleValue(createRecordEventType.clinicalEvaluationUpdateDate, e.target.value), handleKeyDown, elements.inputTypes.date, record.clinicalEvaluationUpdateDateTime), elements.getInput("clinicalEvaluationUpdateTimeInput", disabled, (e) => this.handleValue(createRecordEventType.clinicalEvaluationUpdateTime, e.target.value), handleKeyDown, elements.inputTypes.time, record.clinicalEvaluationUpdateDateTime));
            //d_recanalysis_key = elements.getFormGroup("DynaVision Record Analysis Key", true, elements.getInput("d_recanalysis_keyInput", disabled, (e) => this.handleValue(createRecordEventType.d_recanalysis_key, e.target.value), handleKeyDown, elements.inputTypes.text, record.d_recanalysis_key));
            measuredHrMax = elements.getFormGroup("Maximum HR", true, elements.getInputGroup(elements.getInput("measuredHrMaxInput", disabled, (e) => this.handleValue(createRecordEventType.measuredHrMax, e.target.value), handleKeyDown, elements.inputTypes.text, Math.round(record.measuredHrMax)), "BPM"));
            measuredHrMean = elements.getFormGroup("Average HR", true, elements.getInputGroup(elements.getInput("measuredHrMeanInput", disabled, (e) => this.handleValue(createRecordEventType.measuredHrMean, e.target.value), handleKeyDown, elements.inputTypes.text, Math.round(record.measuredHrMean)), "BPM"));
            measuredHrMin = elements.getFormGroup("Minimum HR", true, elements.getInputGroup(elements.getInput("measuredHrMinInput", disabled, (e) => this.handleValue(createRecordEventType.measuredHrMin, e.target.value), handleKeyDown, elements.inputTypes.text, Math.round(record.measuredHrMin)), "BPM"));
            //measuredHrN = elements.getFormGroup("Measured N HR", true, elements.getInputGroup(elements.getInput("measuredHrNInput", disabled, (e) => this.handleValue(createRecordEventType.measuredHrN, e.target.value), handleKeyDown, elements.inputTypes.text, record.measuredHrN), "BPM"));
            //reportNr = elements.getFormGroup("Report Number", true, elements.getInput("reportNrInput", disabled, (e) => this.handleValue(createRecordEventType.reportNr, e.target.value), handleKeyDown, elements.inputTypes.text, record.reportNr));
            //studyReportNr = elements.getFormGroup("Study Report Number", true, elements.getInput("studyReportNrInput", disabled, (e) => this.handleValue(createRecordEventType.studyReportNr, e.target.value), handleKeyDown, elements.inputTypes.text, record.studyReportNr));
            //symptomsCodeSet = elements.getFormGroup("Symptoms Code Set", true, elements.getInput("symptomsCodeSetInput", disabled, (e) => this.handleValue(createRecordEventType.symptomsCodeSet, e.target.value), handleKeyDown, elements.inputTypes.text, record.symptomsCodeSet));
            symptomsRemark = elements.getFormGroup("Symptoms", true, elements.getInput("symptomsRemarkInput", disabled, (e) => this.handleValue(createRecordEventType.symptomsRemark, e.target.value), handleKeyDown, elements.inputTypes.text, record.symptomsRemark));
            enrollmentReportKey = elements.getFormGroup("Enrollment Report Key", true, elements.getInputGroup(elements.getInput("enrollmentReportKey", disabled, (e) => this.handleValue(createRecordEventType.enrollmentReportKey, e.target.value), handleKeyDown, elements.inputTypes.text, record.enrollmentReportKey)));
        }

        return (
            <Container className="gap group-border" fluid>
                <h4 className="center">Event Data</h4>
                {clinicalEvaluationStartDateTime}
                {symptomsRemark}
                {activitiesRemark}
                {analysisRemark}
                {measuredHrMin}
                {measuredHrMax}
                {measuredHrMean}
                {enrollmentReportKey}
                {showSaveButton && (
                    <div className="button-gap">
                        <Button className="button" onClick={this.handleSave} title={save}>{save}</Button>{' '}
                        <div className="gap" />
                    </div>
                )}
            </Container>
        );
    }
}

export default connect(
    state => ({
        recordsState: state.records
    }),
    dispatch => ({
        recordsDispatch: bindActionCreators(Records.actionCreators, dispatch)
    })
)(CreateRecordEvent);



// WEBPACK FOOTER //
// ./src/components/CreateRecordEvent.js